// ** React Imports
import React, { useEffect, useState } from "react";
import {
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { DropdownOptions } from "../InventoryCalendar/constants/InventoryConstants";
import { getAllNonHiddenRoomTypes } from "../InventoryCalendar/api/InventoryApi";
// import OpenCloseView from "./OpenCloseViews";
import { connect } from "react-redux";
import { handleSpringDataRequest } from "../../api";
import CommonSlider from "../CalendarPage/Views/CommonSlider";
import BulkInventoryCapping from "./BulkInventoryCapping";
import BulkOpenCloseViews from "./BulkOpenCloseViews";
import BulkSetOnlineView from "./BulkSetOnlineView";
import BulkSetPricingView from "./BulkSetPricingView";
import BulkUpdateRatesView from "./BulkUpdateRatesView";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  textField: {
    padding: theme.spacing(2),
  },
  linerProgress: {
    marginBottom: theme.spacing(2),
    width: "100%",
    "& > * + *": {
      marginop: theme.spacing(2),
    },
  },
  header: {
    padding: theme.spacing(2),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
    },
  },
};

const BulkGroupOperations = (props) => {
  const EditRateAccess = true;

  const EditInevntoryAccess = true;

  const { handleAddEventSidebar, open, refresh, bulkHotelData,allHotelsData } = props;

  const [rooms, setRooms] = React.useState();
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedHotel, setselectedHotel] = useState(
    bulkHotelData?.selHotels[0]?.hotelId
  );
  const [actionType, setActionType] = useState(
    EditRateAccess
      ? "set-price"
      : EditInevntoryAccess
      ? "set-inventory"
      : "edit-room"
  );
  const [dataLoading, setDataLoading] = useState(true);
  const [showLine, setShowLine] = useState(false);
  const classes = useStyles();
  //   console.log("bulkHotelData?.selHotels[0]?.hotelId", bulkHotelData?.selHotels);

  const setLineVisible = () => {
    setShowLine(true);
  };

  const setLineInvisible = () => {
    setShowLine(false);
  };

  const isOnlineComponent = (selectType) => {
    if (
      selectType === "set-online" ||
      selectType === "set-offline" ||
      selectType === "block-room" ||
      selectType === "unblock-room" ||
      selectType === "delete-room" ||
      selectType === "edit-room" ||
      "sold-out"
    ) {
      return true;
    }
    return false;
  };

  const getActionName = (name) => {
    const item = DropdownOptions.find((option) => option.val === name);
    return item.text;
  };

  const intialFunc = async () => {
    setLineVisible();
    setDataLoading(true);

    handleSpringDataRequest(
      `core/api/v1/reservation/getAllNonHiddenRoomTypes?hotelId=${selectedHotel}`
    )
      .then((resp) => {
        setSelectedRoom(Object.keys(resp)[0]);
        setRooms(resp);
        setDataLoading(false);
      })
      .catch((err) => {
        setDataLoading(false);
      });
    // let resp = await getAllNonHiddenRoomTypes();
  };

  useEffect(() => {
    intialFunc();
  }, [selectedHotel]);

  const [roomAndPlans, setroomAndPlans] = useState([]);

  useEffect(() => {
    handleSpringDataRequest(
      `core/api/v1/room/get-all-roomtype-obj?hotelId=${selectedHotel}`
    )
      .then((res) => {
        setroomAndPlans(res);
      })
      .catch((err) => console.error(err));
  }, [selectedHotel]);

  const [AccessControl, setAccessControl] = useState([
    {
      EditRateAccess: new Set([
        "Set Pricing",
        "Rate Multiplier",
        "Update Rates from OTA",
        "Min Advanced Booking Offset",
        "Max Advanced Booking Offset",
      ]),
    },
    {
      EditInevntoryAccess: new Set([
        "Set Inventory",
        "Inventory Capping",
        "Set Offline",
        "Set Online",
        "Block Rooms",
        "Unblock Rooms",
        "Set Sold Out",
        "Reassign Room Type",
        "Close/Open Room Type",
        "Close/Open Rate Plan",
        "Close/Open On Arrival",
        "Close/Open On Departure",
        "Min Length of Stay",
        "Max Length of Stay",
        "Delete Rooms",
        "Restore Deleted Rooms",
        "Edit Room Ids",
      ]),
    },
  ]);

  return (
    <div className={classes.root}>
      <CommonSlider
        open={open}
        onClose={() => {
          handleAddEventSidebar();
        }}
      >
        <Grid container>
          <Grid container item xs={12} className={classes.header}>
            <Grid
              container
              xs={10}
              spacing={2}
              justifyContent="flex-start"
              item
            >
              <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Hotels</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedHotel}
                    onChange={(e) => setselectedHotel(e.target.value)}
                    label="Hotels"
                    // MenuProps={MenuProps}
                  >
                    {bulkHotelData?.selHotels?.map((name) => (
                      <MenuItem key={name.hotelId} value={name.hotelId}>
                        {name.hotelName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Action Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={actionType}
                    label="Action Type"
                    title={getActionName(actionType)}
                    onChange={(eve) => {
                      if (isOnlineComponent(eve.target.value)) {
                        setSelectedRoom("all-rooms");
                      }
                      if (
                        selectedRoom === "all-rooms" &&
                        !isOnlineComponent(eve.target.value)
                      ) {
                        setSelectedRoom(Object.keys(rooms)[0]);
                      }
                      setActionType(eve.target.value);
                    }}
                    MenuProps={MenuProps}
                  >
                    {DropdownOptions.map((name) => {
                      if (EditRateAccess) {
                        if (AccessControl[0]["EditRateAccess"].has(name.text)) {
                          return (
                            <MenuItem key={name.text} value={name.val}>
                              {name.text}
                            </MenuItem>
                          );
                        }
                      }
                      if (EditInevntoryAccess) {
                        if (
                          AccessControl[1]["EditInevntoryAccess"].has(name.text)
                        ) {
                          return (
                            <MenuItem key={name.text} value={name.val}>
                              {name.text}
                            </MenuItem>
                          );
                        }
                      }
                    })}
                  </Select>
                </FormControl>
              </Grid>

              {!dataLoading && (
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <FormControl fullWidth>
                    <InputLabel
                      hidden={
                        actionType === "rate-multiplier" ||
                        actionType === "inventory-cap" ||
                        actionType === "Set Max Adv Offset" ||
                        actionType === "Set Cutoff" ||
                        actionType === "Set Max Los" ||
                        actionType === "Set Min Los" ||
                        actionType === "Close On Departure" ||
                        actionType === "Close On Arrival" ||
                        actionType === "Close Room" ||
                        actionType === "Close Rate" ||
                        actionType === "set-inventory" ||
                        actionType === "set-price"
                      }
                      id="demo-simple-select-label"
                    >
                      Room Types
                    </InputLabel>
                    <Select
                      disabled={
                        actionType === "sold-out" ||
                        actionType === "update-ota" ||
                        actionType === "edit-room"
                      }
                      labelId="demo-simple-select-label"
                      onChange={(eve) => {
                        setSelectedRoom(eve.target.value);
                      }}
                      hidden={
                        actionType === "rate-multiplier" ||
                        actionType === "inventory-cap" ||
                        actionType === "Set Max Adv Offset" ||
                        actionType === "Set Cutoff" ||
                        actionType === "Set Max Los" ||
                        actionType === "Set Min Los" ||
                        actionType === "Close On Departure" ||
                        actionType === "Close On Arrival" ||
                        actionType === "Close Room" ||
                        actionType === "Close Rate" ||
                        actionType === "set-inventory" ||
                        actionType === "set-price"
                      }
                      id="demo-simple-select"
                      value={selectedRoom}
                      label="Room Types"
                      MenuProps={MenuProps}
                    >
                      {actionType === "sold-out" && (
                        <MenuItem key="all-rooms" value={"all-rooms"}>
                          {" "}
                          All Rooms
                        </MenuItem>
                      )}
                      {actionType !== "sold-out" &&
                        isOnlineComponent(actionType) && (
                          <MenuItem key="all-rooms" value={"all-rooms"}>
                            {" "}
                            All Rooms
                          </MenuItem>
                        )}
                      {Object.keys(rooms).map((name) => (
                        <MenuItem key={name} value={name}>
                          {rooms[name]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>
            <Grid container xs={2} item justifyContent="flex-end">
              <IconButton title="close" onClick={handleAddEventSidebar}>
                <Close />
              </IconButton>
            </Grid>
          </Grid>
          {showLine && <LinearProgress className={classes.linerProgress} />}
          {!showLine && <Divider sx={{ width: "100%", marginBottom: 2 }} />}

          {!dataLoading && (
            <Grid sx={{ width: "100%", height: "100%" }} container>
              {actionType === "set-price" && (
                <BulkSetPricingView
                  data={props.data}
                  componentType="set-price"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  hotelId={selectedHotel}
                />
              )}
              {actionType === "set-inventory" && (
                <BulkSetPricingView
                  data={props.data}
                  componentType="set-inventory"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  roomAndPlans={roomAndPlans}
                  hotelId={selectedHotel}
                />
              )}
              {actionType === "rate-multiplier" && (
                <BulkInventoryCapping
                  componentType="rate-multiplier"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                  allHotelsData={allHotelsData}
                />
              )}
              {actionType === "inventory-cap" && (
                <BulkInventoryCapping
                  componentType="inventory-cap"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                  allHotelsData={allHotelsData}
                />
              )}
              {actionType === "set-online" && (
                <BulkSetOnlineView
                  data={props.data}
                  componentType="set-online"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                />
              )}

              {actionType === "set-offline" && (
                <BulkSetOnlineView
                  data={props.data}
                  componentType="set-offline"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                />
              )}

              {actionType === "block-room" && (
                <BulkSetOnlineView
                  data={props.data}
                  componentType="block-room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                />
              )}

              {actionType === "unblock-room" && (
                <BulkSetOnlineView
                  data={props.data}
                  componentType="unblock-room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                />
              )}

              {actionType === "delete-room" && (
                <BulkSetOnlineView
                  data={props.data}
                  componentType="delete-room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                />
              )}

              {actionType === "restore" && (
                <BulkSetOnlineView
                  data={props.data}
                  componentType="restore"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                />
              )}

              {actionType === "sold-out" && (
                <BulkUpdateRatesView
                  data={props.data}
                  componentType="sold-out"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                />
              )}

              {actionType === "update-ota" && (
                <BulkUpdateRatesView
                  data={props.data}
                  componentType="update-ota"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
                />
              )}

              {actionType === "reassign" && (
                <BulkSetOnlineView
                  data={props.data}
                  componentType="reassign"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}
               
                />
              )}

              {actionType === "edit-room" && (
                <BulkUpdateRatesView
                  data={props.data}
                  componentType="edit-room"
                  selectedRoom={selectedRoom}
                  rooms={rooms}
                  setLineInvisible={setLineInvisible}
                  refresh={refresh}
                  setLineVisible={setLineVisible}
                  closeFunc={handleAddEventSidebar}
                  hotelId={selectedHotel}

                />
              )}

              {actionType === "Close Rate" &&
                selectedHotel !== undefined &&
                selectedHotel !== null && (
                  <BulkOpenCloseViews
                    componentType="Close Rate"
                    selectedRoom={selectedRoom}
                    rooms={rooms}
                    setLineInvisible={setLineInvisible}
                    refresh={refresh}
                    setLineVisible={setLineVisible}
                    closeFunc={handleAddEventSidebar}
                    roomAndPlans={roomAndPlans}
                    hotelId={selectedHotel}
                  />
                )}

              {actionType === "Close Room" &&
                selectedHotel !== undefined &&
                selectedHotel !== null && (
                  <BulkOpenCloseViews
                    componentType="Close Room"
                    selectedRoom={selectedRoom}
                    rooms={rooms}
                    setLineInvisible={setLineInvisible}
                    refresh={refresh}
                    setLineVisible={setLineVisible}
                    closeFunc={handleAddEventSidebar}
                    roomAndPlans={roomAndPlans}
                    hotelId={selectedHotel}
                  />
                )}

              {actionType === "Close On Arrival" &&
                selectedHotel !== undefined &&
                selectedHotel !== null && (
                  <BulkOpenCloseViews
                    componentType="Close On Arrival"
                    selectedRoom={selectedRoom}
                    rooms={rooms}
                    setLineInvisible={setLineInvisible}
                    refresh={refresh}
                    setLineVisible={setLineVisible}
                    closeFunc={handleAddEventSidebar}
                    roomAndPlans={roomAndPlans}
                    hotelId={selectedHotel}
                  />
                )}

              {actionType === "Close On Departure" &&
                selectedHotel !== undefined &&
                selectedHotel !== null && (
                  <BulkOpenCloseViews
                    componentType="Close On Departure"
                    selectedRoom={selectedRoom}
                    rooms={rooms}
                    setLineInvisible={setLineInvisible}
                    refresh={refresh}
                    setLineVisible={setLineVisible}
                    closeFunc={handleAddEventSidebar}
                    roomAndPlans={roomAndPlans}
                    hotelId={selectedHotel}
                  />
                )}

              {actionType === "Set Min Los" &&
                selectedHotel !== undefined &&
                selectedHotel !== null && (
                  <BulkOpenCloseViews
                    componentType="Set Min Los"
                    selectedRoom={selectedRoom}
                    rooms={rooms}
                    setLineInvisible={setLineInvisible}
                    refresh={refresh}
                    setLineVisible={setLineVisible}
                    closeFunc={handleAddEventSidebar}
                    roomAndPlans={roomAndPlans}
                    hotelId={selectedHotel}
                  />
                )}

              {actionType === "Set Max Los" &&
                selectedHotel !== undefined &&
                selectedHotel !== null && (
                  <BulkOpenCloseViews
                    componentType="Set Max Los"
                    selectedRoom={selectedRoom}
                    rooms={rooms}
                    setLineInvisible={setLineInvisible}
                    refresh={refresh}
                    setLineVisible={setLineVisible}
                    closeFunc={handleAddEventSidebar}
                    roomAndPlans={roomAndPlans}
                    hotelId={selectedHotel}
                  />
                )}

              {actionType === "Set Cutoff" &&
                selectedHotel !== undefined &&
                selectedHotel !== null && (
                  <BulkOpenCloseViews
                    componentType="Set Cutoff"
                    selectedRoom={selectedRoom}
                    rooms={rooms}
                    setLineInvisible={setLineInvisible}
                    refresh={refresh}
                    setLineVisible={setLineVisible}
                    closeFunc={handleAddEventSidebar}
                    roomAndPlans={roomAndPlans}
                    hotelId={selectedHotel}
                  />
                )}

              {actionType === "Set Max Adv Offset" &&
                selectedHotel !== undefined &&
                selectedHotel !== null && (
                  <BulkOpenCloseViews
                    componentType="Set Max Adv Offset"
                    selectedRoom={selectedRoom}
                    rooms={rooms}
                    setLineInvisible={setLineInvisible}
                    refresh={refresh}
                    setLineVisible={setLineVisible}
                    closeFunc={handleAddEventSidebar}
                    roomAndPlans={roomAndPlans}
                    hotelId={selectedHotel}
                  />
                )}
            </Grid>
          )}
        </Grid>
      </CommonSlider>
    </div>
  );
};
function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}

export default connect(mapStateToProps)(BulkGroupOperations);
